module.exports = __webpack_public_path__ + "media/6.2bdc5c98.mp3";